import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_MAIN = theme.palette.primary.main;

  const logo = (
    <Box sx={{ flexGrow: 1, width: 35, height: 35, display: 'flex', ...sx  }}>
      <Typography variant="h4" gutterBottom sx={{ ml: 0, pt: 0.7, color: PRIMARY_MAIN }}>A<span style={{color: 'white'}}>rc</span></Typography>
   </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink style={{ textDecoration: 'none'}} to="/">{logo}</RouterLink>;
}
